import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { EventTrackingService } from 'src/app/services/event-tracking.service';
import { filter, map, take } from 'rxjs/operators';
import { FieldInteraction } from 'src/app/models/event-data.model';
import { Observable, merge, pipe } from 'rxjs';
import { AuthEventType } from 'src/app/enums/event/event.enum';
import { FieldTrackingConfig } from 'src/app/config/eev-form-tracking.config';
import { ContactMethod } from '../../../register/models/customer.model';

const mapFirstInteraction = (contactType: string, payload: FieldInteraction) =>
  pipe(
    filter<any>((val) => 'type' in val && val.type == contactType),
    map<any, FieldInteraction>(() => payload),
    take(1)
  );
@Component({
    selector: 'app-radio-group-contact-method',
    templateUrl: './radio-group-contact-method.component.html',
    styleUrls: ['./radio-group-contact-method.component.scss'],
    standalone: false
})
export class RadioGroupContactMethodComponent implements OnInit {
  @Input() beFormGroup: UntypedFormGroup;
  @Input() beFormControl: UntypedFormControl;
  @Input() beFormControlName: string;
  @Input() contactMethodList: ContactMethod[];

  @Input() phoneTrackingConfig: FieldTrackingConfig;
  @Input() emailTrackingConfig: FieldTrackingConfig;

  constructor(private eventTrackingService: EventTrackingService) {}

  ngOnInit() {
    if (this.beFormControl) {
      const interactions = this.getInteractionObservables();
      merge(...interactions).subscribe((x) =>
        this.eventTrackingService.trackEvent<FieldInteraction>(AuthEventType.FIELD_INTERACTION, x)
      );
    }
  }

  private getInteractionObservables(): Observable<FieldInteraction>[] {
    let interactions: Observable<FieldInteraction>[] = [];
    if (this.phoneTrackingConfig) {
      interactions.push(
        this.beFormControl.valueChanges.pipe(mapFirstInteraction('phone', this.phoneTrackingConfig.event))
      );
    }
    if (this.emailTrackingConfig) {
      interactions.push(
        this.beFormControl.valueChanges.pipe(mapFirstInteraction('email', this.emailTrackingConfig.event))
      );
    }
    return interactions;
  }
}
